<script lang="ts">
    import {PendingPolicy} from "../../models/PendingPolicy";

    import {validateField, alphaNumericPattern} from "../../services/Utilities";
    export let pendingPolicy: PendingPolicy;
    const namePattern = alphaNumericPattern();
</script>

<div class="text-section">
    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Company Name:</label>
             <input bind:value={pendingPolicy.companyName} required pattern={namePattern}/>
                        {#if !validateField(pendingPolicy.companyName, namePattern) }
                                                 <span class="invalidlabel">Valid company name is required</span>
                                               {/if}
        </div>
    </div>
    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Amount of Coverage:</label>
            <input bind:value={pendingPolicy.amountOfCoverage} type="number" min="0" max="9999999999" pattern="\d*" />
                          {#if  pendingPolicy.amountOfCoverage && ( Number(pendingPolicy.amountOfCoverage) < 0 || Number(pendingPolicy.amountOfCoverage) >  9999999999)}
                                                 <span class="invalidlabel">Face amount cannot be over $9,999,999,999</span>
                                               {/if}
        </div>
    </div>
    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Purpose of Coverage:</label>
              <select bind:value={pendingPolicy.purposeOfCoverage} >
                     <option value=''> Select Purpose of Coverage </option>
                     <option value="Personal">Personal</option>
                     <option value="Business">Business</option>
              </select>

        </div>
    </div>
</div>

<style lang="scss">
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/forms" as forms;
</style>
